<template>
  <v-switch
    dense
    v-model="this.$vuetify.theme.dark"
    flat
    :label="this.$vuetify.theme.dark ? 'On' : 'Off'"
    @change="toggle_dark_mode"
  ></v-switch>
</template>

<script>
export default {
  name: 'SwitchDarkMode',
  methods: {
    toggle_dark_mode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString())
    },
  },
}
</script>

<style scoped></style>
